import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import { getPublishPeriodDetails } from "../EventShiftsView/eventsWorkspacePublish.utils";
import styles from "./PublishSchedulerEventsConfirmationModal.module.scss";

/**
 * Confirmation modal for Global Publish / Publish Selected in Event Workspace.
 */
function PublishSchedulerEventsConfirmationModal({
  t,
  isOpen,
  isLoading,
  calendarViewId,
  currentDate,
  shiftCount = 0,
  eventCount = 0,
  onConfirm,
  onClose,
}) {
  const periodDetails = useMemo(
    () => getPublishPeriodDetails(calendarViewId, currentDate),
    [calendarViewId, currentDate],
  );

  const detailRows = [
    {
      label: t(periodDetails.periodLabelKey),
      value: periodDetails.periodValue,
    },
    {
      label: t("scheduler.publishEventShiftShiftsToPublish"),
      value: shiftCount,
    },
    {
      label: t("scheduler.publishEventShiftEventsToPublish"),
      value: eventCount,
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={onClose}>
        <img src={crossIcon} alt="" />
      </span>
      <ModalBody className={styles["publish-modal-body"]}>
        <Text
          size="25px"
          marginBottom="16px"
          weight="500"
          align="left"
          color="#111b45"
        >
          {t("scheduler.publishEventShiftTitle")}
        </Text>
        <p className={styles["publish-modal-message"]}>
          {t(periodDetails.introKey)}
        </p>
        <dl className={styles["publish-modal-details"]}>
          {detailRows.map(({ label, value }) => (
            <div key={label} className={styles["publish-modal-detail-row"]}>
              <dt>{label}:</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
        <p className={styles["publish-modal-message"]}>
          {t("scheduler.publishEventShiftDescription")}
        </p>
        <p className={styles["publish-modal-question"]}>
          {t("scheduler.publishEventShiftConfirmQuestion")}
        </p>
        <div className={styles["publish-modal-actions"]}>
          <button
            type="button"
            className="button button-round button-shadow"
            disabled={isLoading}
            onClick={onConfirm}
          >
            {t("scheduler.publish")}
          </button>
          <button
            type="button"
            className="button button-round button-border button-dark"
            disabled={isLoading}
            onClick={onClose}
          >
            {t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(PublishSchedulerEventsConfirmationModal);
